import React from "react";
import "./Result_card.css";

function Result_card() {
      const percent = 40;
  return (
    <>
      <section className="Result_card card_box">
        <div className="heading_text_holder">
          <h1>Test Completed!</h1>
        </div>
        <div className="row align-items-center">
          <div className="col-xl-3 col-lg-5 col-md-5 col-sm-5">
            <div className="progressbar_holder">
                 <div className="circle_wrapper">
              <div
                className="circular_progress"
                style={{ "--progress": percent }}
              >
                <div className="inner_text">
                  <h3>{percent}%</h3>
                </div>
              </div>
            </div>
            </div>
           
          </div>

          <div className="col-xl-9 col-lg-7 col-md-7 col-sm-7">
            <div className="card_text_holder">
              <h3>dvdg</h3>
              <h4>dfdgs</h4>
              <p>sdfsdf</p>
            </div>
          </div>
        </div>

        <div className="text_holder">
          <h6>Recommendation</h6>
          <p>
            Keep up the effort! We recommend language training before applying
            for international internships. A minimum B1 level is generally
            required.
          </p>
        </div>
      </section>
    </>
  );
}

export default Result_card;
